import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import InvestmentSecurityType from 'src/app/shared/enums/InvestmentSecurityType.enum';
import {LenderInformation} from '../../../../shared/models/LenderInformation.model';
import {CurrencyModel} from '../../../../shared/models/CurrencyModel';
import InterestType from 'src/app/shared/enums/InterestType.enum';
import {LoanType} from 'src/app/shared/enums/LoanType.enum';

export class LenderJuniorInfoDialogModel {
  public lenderInformation: LenderInformation;
  public currency: CurrencyModel;
  public estimatedMarketValue;
  public totalCost;
  public initialSecurityType;
}

@Component({
  selector: 'terra-lender-junior-info-dialog',
  templateUrl: './lender-junior-info-dialog.component.html',
  styleUrls: ['./lender-junior-info-dialog.component.scss']
})
export class LenderJuniorInfoDialogComponent implements OnInit {
  LoanType = LoanType;
  InterestType = InterestType;
  SecurityType = InvestmentSecurityType;

  constructor(@Inject(MAT_DIALOG_DATA) public model: LenderJuniorInfoDialogModel) {
  }

  ngOnInit() {
  }
}
